import { render, staticRenderFns } from "./housingSpecifications.vue?vue&type=template&id=59c8513e&scoped=true&"
import script from "./housingSpecifications.vue?vue&type=script&lang=js&"
export * from "./housingSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./housingSpecifications.vue?vue&type=style&index=0&id=59c8513e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c8513e",
  null
  
)

export default component.exports